import React from "react";
import "./SingleReview.scss";
import Stars from "react-stars-display";
import { MdVerifiedUser } from "react-icons/md";

const SingleReview = () => {
  return (
    <div className="SingleReview">
      <div className="reviewFlex">
        <h2>Malin A.</h2>
        <p>1 day ago</p>
      </div>
      <div className="reviewFlex start">
        <Stars stars={2.4} fill="#FDBB02" size={22} />
        <h5>to [Staff name]</h5>
      </div>
      <p>
        Here is the review text, if its more than 3 rows then it will be hidden
        with 3 dots then it will be liek this with 3 rows wohooo like this
        then...
      </p>
      <div className="reviewFlex">
        <h3>Show more</h3>
        <div className="verification">
          <MdVerifiedUser />
          <span>Verifierad av Bookybook</span>
        </div>
      </div>
    </div>
  );
};

export default SingleReview;
